import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export const EnviarRol = () => {
  //nombre de la pestaña
  document.title = "Enviar Rol";
  const [file, setFile] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    //Calcular la fecha de inicio(siguiente lunes) y la fecha de fin(siguiente domingo) de la siguiente semana
    const today = dayjs();

    let nextMonday;
    let nextSunday;
    //Si es domingo, la fecha de inicio es el día siguiente
    if (today.day() === 0) {
      nextMonday = today.day(1);
      nextSunday = today.day(7);
    } else {
      nextMonday = today.day(1).add(7, "days");
      nextSunday = today.day(7).add(7, "days");
    }
    setStartDate(nextMonday);
    setEndDate(nextSunday);
  }, []);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (allowedTypes.includes(selectedFile.type)) {
        setFile(selectedFile);
        setError("");
      } else {
        setFile(null);
        setError("Solo se permiten archivos PDF, JPG o PNG.");
      }
    }
  };

  const handleSubmit = async () => {
    if (!file || !startDate || !endDate) {
      setError("Por favor, completa todos los campos.");
      return;
    }

    //Si la fecha de inicio es mayor a la fecha de fin mostrar error
    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      setError("La fecha de inicio no puede ser mayor a la fecha de fin.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("start_date", dayjs(startDate).format("YYYY-MM-DD"));
    formData.append("end_date", dayjs(endDate).format("YYYY-MM-DD"));

    setIsLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      const response = await fetch(
        // "http://localhost/rest-api-ase/controllers/email/sendEmail.php", //LocalHost
        "https://ase-fsspx.com/rest-api-ase/controllers/email/sendEmail.php", //hostinger
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        setSuccessMessage("Rol enviado con éxito.");
        setFile(null);
        setStartDate(null);
        setEndDate(null);
      } else {
        setError("Ocurrió un error al enviar los datos.");
      }
    } catch (error) {
      setError("No se pudo conectar con el servidor.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={2}
    >
      <Typography
        id="transition-modal-title"
        variant="h4"
        color="primary"
        fontWeight={900}
      >
        ENVIAR ROL SEMANAL
      </Typography>
      <Typography
        id="transition-modal-title"
        variant="body1"
        color="secondary"
        sx={{ mt: 2 }}
        textAlign={"center"}
      >
        El rol se enviará por correo electrónico únicamente a los acólitos que
        se encuentren activos.
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        width="100%"
        justifyContent={"center"}
        margin={"60px 0"}
      >
        <DatePicker
          label="Fecha de inicio"
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
          sx={{ marginRight: 7 }}
        />

        <DatePicker
          label="Fecha de fin"
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
        />
      </Box>

      <Button
        variant="contained"
        component="label"
        color="primary"
        sx={{ marginBottom: 2 }}
      >
        Adjuntar rol
        <input
          type="file"
          accept=".pdf, .jpg, .jpeg, .png"
          hidden
          onChange={handleFileChange}
        />
      </Button>

      {file && (
        <TextField
          value={file.name}
          InputProps={{
            readOnly: true,
          }}
          fullWidth
          variant="outlined"
          sx={{ marginBottom: 2 }}
        />
      )}

      <Button
        variant="contained"
        color="success"
        onClick={handleSubmit}
        disabled={isLoading || !file || !startDate || !endDate}
        sx={{ marginBottom: 4 }}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Enviar rol"
        )}
      </Button>
      {error && (
        <Typography color="error" variant="h6" gutterBottom>
          {error}
        </Typography>
      )}

      {successMessage && (
        <Typography color="success" variant="h6" gutterBottom>
          {successMessage}
        </Typography>
      )}
    </Box>
  );
};
